import React, { useState } from "react";
import { View, StyleSheet, SafeAreaView } from "react-native";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomTextInput from "../../common/general/CustomTextInput/CustomTextInput";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomRichTextEditor from "../../TextEditor/CustomRichTextEditor";

const EditAssignment = ({
  onClose,
  onSave,
  initialContent,
  newName,
  onChangeName,
  buttonText = "Save",
  activelyEditingState,
}) => {
  const [editorContent, setEditorContent] = useState(initialContent || "");

  const [activelyEditing, setActivelyEditing] = activelyEditingState;

  const handleSave = () => {
    editorRef.current.getContentHtml().then((htmlContent) => {
      onSave(htmlContent);
    });
  };

  return (
    <SafeAreaView style={styles.container}>
      <CustomText style={{ fontSize: "16", fontWeight: 700, marginBottom: 15 }} text={`Assignment Name`} size="xs" />
      <CustomTextInput value={newName} onChangeText={onChangeName} placeholder={`Enter Assignment Name`} />
      <CustomSpacing type="vertical" size="l" />

      <CustomRichTextEditor
        value={editorContent}
        onChange={(content) => {
          setActivelyEditing(true);
          setEditorContent(content);
        }}
        isSubmitting={false}
        placeholder="Enter assignment description"
        activelyEditing={activelyEditing}
      />

      {/* Save and Cancel Buttons */}
      <View style={styles.buttonContainer}>
        <CustomButton
          text={buttonText} // Dynamic button text (Add or Save)
          onPress={handleSave}
          styleType="primary"
          size="m"
        />
        <CustomButton text="Cancel" onPress={onClose} styleType="primaryLight" size="m" />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    width: "100%",
    flex: 1,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 10,
  },
});

export default EditAssignment;
